import React, { FC } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import {
  GParagraphLG,
  GResponsiveText,
  GTitleLG,
  GTitleXL,
  GTitleXS,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

export const SeniorDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  return (
    <div className="mt-3 grid gap-16">
      <div>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawaySeniorExplainer1',
            "The Senior isn't just a football movie; it's the cinematic touchdown of the summer. This September 19, witness the unbelievable true story of Mike Flynt, a 59-year-old man who defied logic, strapped on his pads, and returned to the gridiron decades after he last played.",
          )}
        </GParagraphLG>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'giveawaySeniorxplainer2',
            "Bruised, doubted, and nearly broken, Mike isn't fighting for glory. He's fighting for the teammates he lost, the family he fractured, and the ending he still believes is possible. It's the comeback story you have to see to believe",
          )}
        </GParagraphLG>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawaySeniorxplainer4',
            'Experience The Senior only in theaters starting September 19. Pre-order your tickets now to secure your seat for the game of a lifetime and automatically enter for your shot at over $113,000 in prizes!',
          )}
        </GParagraphLG>
      </div>
      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3 uppercase"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GTitleXL}
        >
          {t('seniorGrandPrize', 'Grand Prize – VIP Big Game Experience')}
        </GResponsiveText>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawaySeniorGrandPrizeDesc',
            'Win $50,000 cash to purchase a trip for two to the biggest game of the year!',
          )}
        </GParagraphLG>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawaySeniorGrandPrizeDesc2',

            'That’s enough to include: First-class flights, luxury limo service, premium lower-bowl seats, 5-star hotel for 3 nights, fine dining, merch, and more!',
          )}
        </GParagraphLG>
      </div>

      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3 uppercase"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GTitleXL}
        >
          {t('seniorWeeklyPrizeTitle', 'Weekly Giveaway - $10,000 Cash for College Football Season Tickets')}
        </GResponsiveText>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'seniorWeeklyPrize',
            'Every week, one winner scores $10,000 in cash to buy season tickets to the college football team of their choice. Six winners in total will be chosen.',
          )}
        </GParagraphLG>
      </div>
      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3 uppercase"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GTitleXL}
        >
          {t('seniorScholarshipPrize', 'Full-Ride Scholarships to Sul Ross State University– Five Winners')}
        </GResponsiveText>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'seniorScholarshipPrizeDesc2',
            'Win a full-ride scholarship (tuition, room, board) to Sul Ross State University. Five winners. Five dreams funded.',
          )}
        </GParagraphLG>

        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mt-4"
          MobileTextComponent={GTitleXS}
          DesktopTextComponent={GTitleXS}
        >
          {t(
            'giveawaySchedule2',
            "Don't Miss the Kickoff! Pre-Order Your Tickets to The Senior Now! In theaters on September 19, 2025!",
          )}
        </GResponsiveText>
      </div>
    </div>
  )
}
